import { IFood } from "../models/IFood";
import { configWithWebToken } from "./config";

export const getMenuByRestaurantId = (restaurantId: string) => {
  // Public uc: menu, giris yapmadan da goruntulenebilir.
  return configWithWebToken.get<IFood[]>(`Menu/MenuListByRestourantId/${restaurantId}`);
};
